export const CDN_MOBILE_ASSETS_DEV_URL = 'https://cdn.dev.mysports-rewards.com';
export const CDN_MOBILE_ASSETS_PROD_URL = 'https://cdn.mysports-rewards.com';
export const GETSTREAM_APP_ID_DEV = '1350865';
export const GETSTREAM_APP_ID_PROD = '1350866';
export const GETSTREAM_BETA_ORG_ID = '1250434';
export const GETSTREAM_BETA_APP_ID_DEV = '1444045';
export const GETSTREAM_BETA_APP_ID_PROD = '1448140';
export const FASTRELAY_APP_ID_DEV = 'app_cdd06dd74c71413f';
export const FASTRELAY_APP_ID_PROD = 'app_83d89059a6d24a44';
export const GO_MOVEREPUBLIC_DEV_URL = 'https://go.dev.moverepublic.com';
export const GO_MOVEREPUBLIC_PROD_URL = 'https://go.moverepublic.com';
